// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"6993373a","122":"91000cf3","139":"34f3d2b6","301":"397f402c","453":"a89f8f11","580":"446b7a86","597":"ec7d9740","826":"07d7e94c","872":"bc4ff42e"}[chunkId] + ".chunk.js";
};